import { anzeigeNummer } from '../../domain/candidateSort';
import { useT } from '../../i18n';
import { requireCandidate, selectExam, useAppStore } from '../../store/useAppStore';
import { Dialog } from '../../ui/Dialog';
import { Icon } from '../../ui/Icon';
import styles from './CandidatesSheet.module.css';

/**
 * Rückfrage vor dem Prüflingswechsel.
 *
 * Sie steht bewusst im Weg: Ein Fehlgriff in der Liste würde sonst mitten in einer laufenden
 * Station den Bogen austauschen. Verloren geht dabei nichts — die Eingaben bleiben je Prüfling
 * erhalten —, aber der Prüfer soll wissen, dass er die Station gerade verlässt.
 */
export function SwitchDialog() {
  const t = useT();
  const exam = useAppStore(selectExam);
  const current = useAppStore(requireCandidate);
  const targetId = useAppStore((s) => s.switchTarget);
  const cancel = useAppStore((s) => s.cancelSwitch);
  const confirm = useAppStore((s) => s.confirmSwitch);

  const target = exam.candidates.find((c) => c.id === targetId);
  // Ob für den Zielprüfling schon etwas auf dem Gerät liegt — nicht, ob er als „bewertet"
  // geführt wird. Eine Punktzahl aus der Prüfungsverwaltung ist noch kein Bogen, den wir
  // öffnen könnten; das zu versprechen wäre gelogen.
  const hasDraft = useAppStore((s) => (targetId ? s.assessments[targetId] != null : false));

  if (!target) return null;

  const detail =
    (hasDraft ? t.switchCandidate.withDraft(target.name) : t.switchCandidate.blank) +
    ' ' +
    t.switchCandidate.kept(current.name);

  return (
    <Dialog
      kicker={t.switchCandidate.kicker}
      title={[target.name, anzeigeNummer(target)].filter(Boolean).join(' · ')}
      onClose={cancel}
      width={500}
    >
      <p className={styles.switchText}>{detail}</p>
      <div className={styles.switchButtons}>
        <button type="button" className={`tap ${styles.cancel}`} onClick={cancel}>
          <Icon name="close" size={16} />
          <span>{t.switchCandidate.cancel}</span>
        </button>
        <button type="button" className={`tap ${styles.confirm}`} onClick={confirm}>
          <Icon name="swap" size={16} />
          <span>{t.switchCandidate.confirm}</span>
        </button>
      </div>
    </Dialog>
  );
}
